import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Modal, UiCoreModule } from '@softline/ui-core';

@Component({
    selector: 'soft-create-belegvermerk',
    templateUrl: './create-belegvermerk.component.html',
    styleUrls: ['./create-belegvermerk.component.scss'],
    imports: [
        ReactiveFormsModule,
        UiCoreModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateBelegvermerkComponent implements OnInit, OnDestroy, Modal<string | null> {

  close!: (result: string | null) => void;

  form = this.fb.group({
    belegvermerk: ['', [Validators.required, Validators.minLength(1)]]
  });

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.form.reset();
  }

  registerCloseHandler(handler: (result: string | null) => void) {
    this.close = handler;
  }

  onSubmit(): void {
    if (this.form.invalid) { return; }
    this.close(this.form.value.belegvermerk ?? '');
  }
}
